import { CircularProgress, Container, Grid, IconButton, LinearProgress, Stack, Tooltip, Typography } from "@mui/material";
import AlertService from "../../services/AlertService";
import ProductoService from "../../services/ProductoService";
import UsuarioService from "../../services/UsuarioService";
import BusqScopusTable from "../../componentes/Scopus/BusqScopus";
import { CasUserContext } from "../../services/casUserContext";
import { useContext, useEffect, useState } from "react";
import { Scopus } from "../../interfaces/Scopus";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { ImportadoScopusDTO } from "../../interfaces/ImportadoScopusDTO";

const alertaService = new AlertService();
const productoService = new ProductoService();
const usuarioService = new UsuarioService();

export function ProductoScopusPage() {
    const[listScopus,setListScopus] = useState<Array<Scopus>>([]);
    const[listImportados,setListImportados] = useState<Array<ImportadoScopusDTO>>([]);
    const[scopusResp,setScopusResp] = useState(true);
    const[auth,setAuth] = useState(false);
    let [progress, setProgress] = useState(0);
   
    const casUserContext = useContext(CasUserContext);
    const user = casUserContext.userData;

    const fetchData = async () =>{
      let ListEid:Array<string> = [];
      try{     
            alertaService.showLoading("Espere...");
            setScopusResp(false);
            //await productoService.GetListScopus(idinv,token)
            await productoService.GetListImportadosScopus(user.token)
            .then((data) => {
              alertaService.hideLoading();
              if(data.status.isSuccessfully) {
                //console.log(data.listData);
                setListImportados(data.listData);
                let listaScopuseid:Array<string> = data.listData.map(objeto => objeto.scopuseid);
                ListEid = listaScopuseid;
                //console.log(ListEid);
              }else{
                setListImportados([]);
            }
            })
            .catch((error) => {
              alertaService.hideLoading();
              alertaService.alertaAdvertencia("Error",error);
              console.error(error)
            }); 
            //await productoService.GetListScopus(idinv,token)
            await productoService.GetListScopusSpecific(user.idinv,user.token)
            .then((data) => {
              alertaService.hideLoading();
              if(data.status.isSuccessfully) {
                //alertaService.alertaExito("Exito","Se obtuvo respuesta.");
                //console.log(data.listData);
                let resultadoFiltrado = data.listData.filter(objeto1 =>
                  !ListEid.includes(objeto1.eid)
                );
                //console.log(resultadoFiltrado)
                if(ListEid.length > 0){
                  setListScopus(resultadoFiltrado);
                }else{
                  setListScopus(data.listData);
                  //console.log(data.listData);
                }                
              }else{
                alertaService.alertaAdvertencia("Alerta","No se encontraron resultados.");
            }
            })
            .catch((error) => {
              alertaService.hideLoading();
              alertaService.alertaAdvertencia("Error",error);
              console.error(error)
            });
            setProgress(100);             
            setInterval(() => {
              setScopusResp(true);
            }, 500);
        }catch(error){
          console.error('Error:',error);
        }
    };

    const simulateLoading = () => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          setProgress((prevProgress) => {
            const newProgress = prevProgress + 10; // Incremento de progreso
            if (newProgress >= 90) {
              clearInterval(interval);
            }
            return newProgress;
          });
        }, 1000); // Intervalo de simulación
      });
    };

    useEffect(() => {  
      //console.log(user);
      const flag = usuarioService.authorized(user.roles);
      setAuth(flag);  
      if(flag){
        fetchData();
      }           
    },[user]);

    useEffect(() => {  
      //console.log(user);
      const flag = usuarioService.authorized(user.roles);
      setAuth(flag);  
      if(flag){
        simulateLoading();
      }           
    },[user]);
    
    return(
      <Container sx={{mt:4}}>
        {auth ? 
        <>
        {scopusResp 
            ? <BusqScopusTable rowsPerPage={[5 ,10, 25, 100]} data={listScopus} idpersona={user.idinv}/> 
            : 
          <Stack sx={{ width: '100%' }} spacing={2}>
            <LinearProgress variant="determinate" value={progress} color="secondary"/>
          </Stack>
        }
        </> 
        : 
        <UnauthorizedPage/>}
      </Container>  
    )
}